export default __webpack_public_path__ + "static/media/pic1.35c0d705.png";